import React, { useEffect, useState } from "react";
import { getdownload } from "../api/api";
import { useParams } from "react-router-dom";

const Preview = () => {
  const [iframeUrl, setIframeUrl] = useState(null);
  const [fileName, setFileName] = useState("");
  const { fileid } = useParams();
  const process = "xml_to_html";

  const fetchFile = async () => {
    try {
      const response = await getdownload(fileid, process);
      if (!response || !response.data.content) {
        throw new Error("No encoded content found in response");
      }

      // Properly decode base64 into UTF-8
      const base64 = response.data.content;
      const decodedHtml = decodeURIComponent(
        Array.prototype.map
          .call(
            atob(base64),
            (c) => "%" + c.charCodeAt(0).toString(16).padStart(2, "0")
          )
          .join("")
      );

      setFileName(response.data.file_name);

      const blob = new Blob([decodedHtml], { type: "text/html" });
      const url = URL.createObjectURL(blob);
      setIframeUrl(url);
    } catch (err) {
      console.error("Error fetching or decoding file:", err);
      setIframeUrl(null);
    }
  };

  useEffect(() => {
    fetchFile();

    // Cleanup old URL on unmount
    return () => {
      if (iframeUrl) URL.revokeObjectURL(iframeUrl);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="w-full h-full flex flex-col p-10 text-left gap-8">
      <h2 className="text-left font-bold text-2xl">HTML Preview</h2>
      <p className="text-lg">{`File Name : ${fileName}`}</p>

      <div className="w-full h-full">
        {!iframeUrl ? (
          <p>Loading...</p>
        ) : (
          <iframe
            className="w-full h-[80vh]"
            src={iframeUrl}
            title="HTML Preview"
            style={{ border: "none" }}
          />
        )}
      </div>
    </div>
  );
};

export default Preview;
